/**
 * Created by shaochj on 2017/7/4.
 */
var CryptoJS = require("crypto-js");
/**
 * 前端签名工具类
 */
export default {
    /**
     * 签名
     * @param params 参数
     * @param   url 请求地址
     * @returns {*}
     */
    sign:function (params,url) {
        var arrParams = [];
        if(params){
            for(var key in params){
                var str = key + "=" + params[key];
                arrParams.push(str);
            }
            arrParams = arrParams.sort();
        }else{
            params = {};
        }
        var strParams = arrParams.length>0?arrParams.join("&"):"";
        if(url){
            var route = url.substring(url.indexOf("//")+2);
            route = route.substring(route.indexOf("/"));
            if(strParams){
                strParams = route+"?"+strParams;
            }else{
                strParams = route;
            }
        }
        // console.log("strParams==",strParams);
        var autograph = 'w83keis394jc55klua36';
        var paramsMD5 = CryptoJS.MD5(strParams+autograph).toString();
        params.sig = paramsMD5;
        return params;
    }
}


// WEBPACK FOOTER //
// ./src/pub/utils/SignUtil.js